import { Injector } from 'typed-inject';

import type { BaseInjectionContext } from '@/di/base-injector';

import { VueRouterAdapter } from './services/vue-router-adapter';
import { UserProfileStoreProviderAdapter } from './services/user-profile-provider';
import { PermissionsServiceTokens as Tokens } from './di-tokens';

export function providePermissionServices<TContext extends BaseInjectionContext>(baseInjector: Injector<TContext>) {
    return baseInjector
        .provideClass(Tokens.RouterAdapter, VueRouterAdapter)
        .provideClass(Tokens.UserProfileProvider, UserProfileStoreProviderAdapter);
}

export { Tokens as PermissionsServiceTokens };
